import { createUseStyles } from "react-jss";

export const FormFieldStyle = createUseStyles((theme: any) => ({
    container: {
        width: "100%",
        display: "flex",
    },
}));
